import * as actionTypes from "../actionTypes";
import { objToArr } from "../../helpers";
import { makeAllObjToArr } from "../../helpers";
const initialState = {
  // account management
  account: null,
  company_setting: null,
  account_management: null,
  is_error: false,
  is_loading: false,
  is_delete_btn_loading: false,
  is_delete_btn_id: "",
  is_add_btn_loading: false,
  is_modal_loading: false,
  companyNameModal: false,
  documentModal: false,
  accountingModal: false,
  accAdminModal: false,
  changePlanModal: false,
  changeTopupModal: false,
  changePosCountModal: false,
  is_accAdmin_modal_loading: false,
  is_changePlan_modal_loading: false,
  is_changeTopup_modal_loading: false,
  is_changePosCount_modal_loading: false,
  is_save_payment_loading: false,
  is_cancel_account_loading: false,
  cancelAccModal: false,
  code_list: [],
  invoice_list: [],
  invoice_detail: null,
  is_invoice_detail_modal_loading: false,
  invoiceDetailModal: false,
  // user-management
  user_management_details: null,
  user_merchant_list: [],
  addLinkEmpModal: false,
  is_add_link_emp_modal_loading: false,
  is_update_management_loading: false,
  permission_group_list: [],
  // cluster-settings
  cluster_details: null,
  redirect_path: "",
  add_cluster_details: null,
  selected_cluster_details: null,
  is_save_cluster_loading: false,
  cluster_modules: [],
  addClusSettingsModal: false,
  is_add_cluster_settings_loading: false,
  addClusStoreModal: false,
  is_add_cluster_store_loading: false,
  /* finance - settings */
  // general settings
  finance_general_details: null,
  is_save_general_details_loading: false,
  finance_sale_details: null,
  is_save_payment_method_loading: false,
  payMethodModal: false,
  servicePeriodModal: false,
  is_service_period_loading: false,
  group_account: null,
  saleTypeModal: false,
  is_sale_type_loading: false,
  saleGroupModal: false,
  is_sale_group_loading: false,
  channelModal: false,
  is_channel_loading: false,
  public_holiday_details: null,
  publicHolidayModal: null,
  is_public_holiday_loading: false,
  master_setting_details: null,
  pmMasterSettingModal: false,
  is_pmMasterSetting_loading: false,
  editPmMasterSettingModal: false,
  is_editPmMasterSetting_loading: false,
  salesMasterSettingModal: false,
  is_salesMasterSetting_loading: false,
  editSalesMasterSettingModal: false,
  is_editSalesMasterSetting_loading: false,
  servicePeriodsMasterSettingModal: false,
  is_servicePeriodsMasterSetting_loading: false,
  editServicePeriodsMasterSettingModal: false,
  is_editServicePeriodsMasterSetting_loading: false,
  channelsMasterSettingModal: false,
  is_channelsMasterSetting_loading: false,
  editChannelsMasterSettingModal: false,
  is_editChannelsMasterSetting_loading: false,
  // chart of accounts
  chart_of_accounts_details: null,
  sub_accounts_details: null,
  add_accounts_details: null,
  sub_acc_transactions_details: null,
  is_redirect_accounts_id: false,
  newDebitCreditDetail: null,
  // Forecast
  forecast_detail: null,
  addRevenueRuleModal: false,
  editRevenueRuleModal: false,
  editRevenueRuleId: "",
  editRevenueRuleDetail: null,
  addCostModal: false,
  // onlife
  onLifeData: null,
  // Reconcile
  reconcile_detail: null,
  addReconcileModal: false,
  is_addReconcileModal_loading: false,
  delete_reconcile_id: "",
  redirect_reconcile_id: "",
  redirect_reconcile_page: false,

  // pos master --> pos master
  pos_master_data: null,
  pos_master_form_options: null,
  pos_integration_data: null,
  pos_form_state: false,
  pos_integration_modal_state: false,

  // pos master --> layout master
  rooms_layout_data: null,
  edit_room_layout_data: null,
  rooms_layout_form_state: false,

  // pos master --> layout master
  table_master_data: null,
  table_master_edit_form_data: null,
  table_master_form_data: null,
  table_master_form_state: false,

  // pos master --> hardware master
  hardware_master_data: null,
  hardware_master_form_data: null,
  qualification_selection_data: null,
  edit_hardware_master_data: null,
  hardware_details_session_data: null,
  hardware_form_state: false,
  hardware_modal_state: false,

  //  Inventory
  inventory_general_settings_data: null,
  inventory_count_settings_data: null,
  inventory_edit_count_settings_data: null,
  inventory_item_modal_state: null,

  // labour
  labour_employee_form_state: false,
  labour_employee_add_banking_modal_state: false,
  labour_employee_add_document_modal_state: false,
  labour_employee_add_tax_document_modal_state: false,
  labour_employee_dependents_modal_state: false,

  labour_add_form_options: null,

  labourEmployeeList: null,
  labourEmployeeEditData: null,

  labourEmployeeBankingInfo: null,
  labourEmployeeDocumentInfo: null,
  labourEmployeeTaxDocumentInfo: null,
  labourEmployeeDependentsInfo: null,

  clipboard_checklist_modal_state: false,

  // clipboard
  clipboardData: null,

  // promotions
  promotionsData: null,
  promotionsFormData: null,
  promotion_period_modal_state: false,
  add_promo_modal_state: false,
  promotionPeriodData: false,
  promotionEditData: false,
  promo_data_form_type: "add",
  promotionQualificationCriteria: null,
  qualification_modal_state: false,

  // qr ordering
  qrOrderData: null,
  pdfMenuModal: false,
  editPdfMenuData: null,
  menuSequencingData: null,
  qrList: null,

  // ordrr online
  ordrrOnlineMenuSequencingData: null,
  ordrrOnlineData: null,
  deliveryPartnerData: null,
  deliveryPartnerModal: false,

  // integration
  apiKeyList: null,
  confirm_pass_modal: false,
  confirmPasswordStatus: false,
  generate_api_key_modal: false,
  integrationData: null,
  integrationEditData: null,
  pause_store_modal: false,
};

// helper function

const settingReducer = (state = initialState, action) => {
  const { type, payload = {}, valType } = action;
  switch (type) {
    case actionTypes.ACCOUNT_SETTING_DETAILS_FAILED:
    case actionTypes.COMPANY_SETTING_DETAILS_FAILED:
    case actionTypes.CODE_LIST_DETAILS_FAILED:
    case actionTypes.ACCOUNT_MANAGEMENT_DETAILS_FAILED:
    case actionTypes.GET_INVOICE_LIST_FAILED:
    case actionTypes.GET_USER_MANAGE_DETAILS_FAILED:
    case actionTypes.GET_CLUSTER_SETTINGS_FAILED:
      return {
        ...state,
        ...payload,
        is_error: true,
      };
    case actionTypes.ACCOUNT_SETTING_DETAILS_SUCCEEDED:
    case actionTypes.COMPANY_SETTING_DETAILS_SUCCEEDED:
    case actionTypes.CODE_LIST_DETAILS_SUCCEEDED:
    case actionTypes.ACCOUNT_MANAGEMENT_DETAILS_SUCCEEDED:
    case actionTypes.GET_INVOICE_LIST_SUCCEEDED:
    case actionTypes.GET_USER_MANAGE_DETAILS_SUCCEEDED:
    case actionTypes.GET_CLUSTER_SETTINGS_SUCCEEDED:
      return {
        ...state,
        ...payload,
        is_error: false,
      };
    case actionTypes.SETTING_VALUE_CHANGE:
      return {
        ...state,
        [valType]: payload,
      };
    case actionTypes.SETTING_COMPANY_NAME_MODAL_SHOW:
      return {
        ...state,
        companyNameModal: true,
      };
    case actionTypes.SETTING_COMPANY_NAME_MODAL_HIDE:
      return {
        ...state,
        companyNameModal: false,
      };
    case actionTypes.SETTING_DOC_MODAL_SHOW:
      return {
        ...state,
        documentModal: true,
      };
    case actionTypes.SETTING_DOC_MODAL_HIDE:
      return {
        ...state,
        documentModal: false,
      };
    case actionTypes.SETTING_ACCOUNTING_MODAL_SHOW:
      return {
        ...state,
        accountingModal: true,
      };
    case actionTypes.SETTING_ACCOUNTING_MODAL_HIDE:
      return {
        ...state,
        accountingModal: false,
      };
    case actionTypes.ACCOUNT_SETTING_INITIAL_STATE:
      return initialState;

    // onlife
    case actionTypes.SAVE_ON_LIFE_DATA: {
      const data = payload;
      return { ...state, onLifeData: { ...data } };
    }
    // posMaster
    case actionTypes.SAVE_POS_MASTER_DATA: {
      const data = payload;
      return { ...state, pos_master_data: { ...data } };
    }
    case actionTypes.SAVE_POS_MASTER_FORM_OPTIONS: {
      let data = payload;
      const station_type = objToArr(payload.station_type);
      const stationStatus = objToArr(payload.stationStatus);
      const deviceMaker = objToArr(payload.deviceMaker);
      const timeout = objToArr(payload.timeout);
      const service_charges_applied = objToArr(payload.service_charges_applied);
      const yes_no = objToArr(payload.yes_no);
      const auto_exit_ticket_upen_fire = objToArr(
        payload.auto_exit_ticket_upen_fire
      );
      const posRooms = objToArr(payload.posRooms);
      const upload_download = objToArr(payload.upload_download);
      const trigger_type = objToArr(payload.trigger_type);
      const applicable_module = objToArr(payload.applicable_module);

      const landing_page_main_widget_preferences = [
        { value: "0", label: "None (Show Logo)" },
        { value: "1", label: "Table Layout Only" },
        { value: "2", label: "Summary Stats Only" },
        { value: "3", label: "Both (Table Layout Default)" },
      ];
      const auto_prepare_order_items = [
        { value: "End of Day", label: "End of Day" },
        { value: "End of Service Period", label: "End of Service Period" },
        { value: "Upon Ticket Payment", label: "Upon Ticket Payment" },
      ];
      const fire_button_outcome = objToArr(payload.fire_button_outcome);
      data = {
        ...data,
        station_type,
        stationStatus,
        deviceMaker,
        timeout,
        service_charges_applied,
        yes_no,
        auto_exit_ticket_upen_fire,
        landing_page_main_widget_preferences,
        auto_prepare_order_items,
        posRooms,
        upload_download,
        trigger_type,
        applicable_module,
        fire_button_outcome,
      };
      return { ...state, pos_master_form_options: { ...data } };
    }
    case actionTypes.SAVE_EDIT_POS_MASTER_FORM_DATA: {
      let data = payload;
      return { ...state, pos_master_Edit_form_data: { ...data } };
    }
    case actionTypes.SAVE_APPLICABLE_MODULE: {
      const data_type = objToArr(payload);
      return {
        ...state,
        pos_master_form_options: {
          ...state.pos_master_form_options,
          data_type,
        },
      };
    }
    case actionTypes.SAVE_FREQUENCY: {
      const frequency = objToArr(payload);
      return {
        ...state,
        pos_master_form_options: {
          ...state.pos_master_form_options,
          frequency,
        },
      };
    }
    case actionTypes.SAVE_POS_INTEGRATION_SETTING_DATA: {
      return { ...state, pos_integration_data: payload };
    }

    case actionTypes.SAVE_ROOMS_LAYOUT_DATA: {
      return { ...state, rooms_layout_data: payload };
    }
    case actionTypes.SAVE_EDIT_ROOM_LAYOUT: {
      return { ...state, edit_room_layout_data: payload };
    }
    case actionTypes.SAVE_TABLE_MASTER_DATA: {
      return { ...state, table_master_data: payload };
    }
    case actionTypes.SAVE_TABLE_MASTER_FORM_DATA: {
      const rooms = objToArr(payload.rooms);
      return { ...state, table_master_form_data: { ...payload, rooms } };
    }
    case actionTypes.SAVE_EDIT_TABLE_MASTER_FORM_DATA: {
      return { ...state, table_master_edit_form_data: payload };
    }
    case actionTypes.SAVE_HARDWARE_MASTER_DATA: {
      return {
        ...state,
        hardware_master_data: payload,
      };
    }
    case actionTypes.SAVE_HARDWARE_MASTER_FORM_DATA: {
      const customer_kitchen_ticket = [
        { value: "1", label: "Upon Hold" },
        { value: "2", label: "Upon Fire" },
      ];

      const menu_item_pricing_scale = [
        { value: "Kilograms", label: "Kilograms" },
        { value: "Grams", label: "Grams" },
      ];

      const zero_value_items_receipts = [
        {
          value: "1",
          label: "Only for Menu Items (Standard, Bundled, and Open)",
        },
        { value: "2", label: "Only for Bundled Menu Item Components" },
        {
          value: "3",
          label: "Show for all Menu Items and Bundled Menu Item Components",
        },
        { value: "4", label: "Never Show" },
      ];

      const print_receipt_upon_successful_payment = [
        {
          value: "1",
          label: "Customer and merchant copy",
        },
        { value: "2", label: "Merchant copy only" },
        {
          value: "3",
          label: "Customer copy only",
        },
        { value: "4", label: "None" },
      ];
      const status_id = objToArr(payload.status_id);
      const hardware_type = objToArr(payload.hardware_type);
      const all_hardware_markers = objToArr(payload.hardware_marker);
      const hardware_marker = [];
      const all_hardware_models = objToArr(payload.hardware_model);
      const hardware_model = [];
      const linked_station = objToArr(payload.linked_station);
      // const linked_station = [];
      const qualification_level = objToArr(payload.qualification_level);
      const card_machine_linked_pm = objToArr(payload.card_machine_linked_pm);
      const printer_name_used = objToArr(payload.printer_name_used);
      const yes_no = objToArr(payload.yes_no);
      const hardware_connection_type = objToArr(
        payload.hardware_connection_type
      );

      return {
        ...state,
        hardware_master_form_data: {
          ...payload,
          status_id,
          hardware_type,
          hardware_marker,
          hardware_model,
          linked_station,
          qualification_level,
          yes_no,
          hardware_connection_type,
          card_machine_linked_pm,
          printer_name_used,
          customer_kitchen_ticket,
          menu_item_pricing_scale,
          zero_value_items_receipts,
          print_receipt_upon_successful_payment,
          all_hardware_models,
          all_hardware_markers,
        },
      };
    }
    case actionTypes.SET_HARDWARE_MODEL: {
      const hardware_model = [
        state.hardware_master_form_data.all_hardware_models[payload - 1],
      ];
      return {
        ...state,
        hardware_master_form_data: {
          ...state.hardware_master_form_data,
          hardware_model,
        },
      };
    }
    case actionTypes.SET_HARDWARE_MAKER: {
      const hardware_marker = [
        state.hardware_master_form_data.all_hardware_markers[payload - 1],
      ];
      return {
        ...state,
        hardware_master_form_data: {
          ...state.hardware_master_form_data,
          hardware_marker,
        },
      };
    }
    case actionTypes.SAVE_QUALIFICATION_SELECTION: {
      let qualification_selection_data = objToArr(payload);
      return {
        ...state,
        hardware_master_form_data: {
          ...state.hardware_master_form_data,
          qualification_selection_data,
        },
      };
    }
    case actionTypes.SAVE_EDIT_HARDWARE_MASTER_DATA: {
      // let edit_hardware_master_data = {};

      // makeAllObjToArr(payload, edit_hardware_master_data);

      return {
        ...state,
        edit_hardware_master_data: payload.tableMaster,
      };
    }
    case actionTypes.SAVE_HARDWARE_DETAILS_SESSION: {
      const status = [
        {
          value: "1",
          label: "Active",
        },
        { value: "2", label: "Inactive" },
      ];

      let hardware_details = makeAllObjToArr(payload);
      hardware_details = {
        ...hardware_details,
        status,
      };
      console.log(hardware_details, "hardware_details_session_data");

      return {
        ...state,
        hardware_details_session_data: {
          ...state.hardware_details_session_data,
          ...hardware_details,
        },
      };
    }
    case actionTypes.SET_MODAL_STATE: {
      return { ...state, [payload.modalName]: payload.modalState };
    }

    case actionTypes.SET_FORM_STATE: {
      return { ...state, [payload.formName]: payload.formState };
    }

    case actionTypes.SAVE_INVENTORY_GENERAL_SETTINGS_DATA: {
      const inventory_general_settings_data = makeAllObjToArr(payload, [
        "inventoryGeneralSettings",
        "inventory_general_setting",
      ]);
      return { ...state, inventory_general_settings_data };
    }

    case actionTypes.SAVE_INVENTORY_COUNT_SETTINGS_DATA: {
      const weekly = {
        0: "Monday",
        1: "Tuesday",
        2: "Wednesday",
        3: "Thursday",
        4: "Friday",
        5: "Saturday",
        6: "Sunday",
      };
      const data = { ...payload, weekly };
      const inventory_count_settings_data = makeAllObjToArr(data, [
        "general_setting",
      ]);
      return { ...state, inventory_count_settings_data };
    }
    case actionTypes.SAVE_EDIT_INVENTORY_COUNT_SETTINGS_DATA: {
      // const inventory_edit_count_settings_data = makeAllObjToArr(payload, [
      //   "general_setting",
      // ]);
      return {
        ...state,
        inventory_edit_count_settings_data: payload?.inventory_count_setting,
      };
    }

    case actionTypes.SAVE_LABOUR_ADD_EMPLOYEE_FORM_DATA: {
      const labour_add_form_options = makeAllObjToArr(payload, []);
      return {
        ...state,
        labour_add_form_options,
      };
    }
    case actionTypes.SAVE_LABOUR_EMPLOYEE_LIST: {
      // const labour_add_form_options = makeAllObjToArr(payload, []);
      return {
        ...state,
        labourEmployeeList: payload,
      };
    }
    case actionTypes.SAVE_EDIT_LABOUR_EMPLOYEE_DATA: {
      return {
        ...state,
        labourEmployeeEditData: payload,
      };
    }
    case actionTypes.SAVE_EMPLOYEE_BANKING_INFO: {
      return {
        ...state,
        labourEmployeeBankingInfo: payload,
      };
    }
    case actionTypes.SAVE_EMPLOYEE_DOCUMENT_INFO: {
      const documents = payload?.filter((el) => el?.document_type === 1);
      return {
        ...state,
        labourEmployeeDocumentInfo: documents,
      };
    }
    case actionTypes.SAVE_EMPLOYEE_TAX_DOCUMENT_INFO: {
      const taxDocuments = payload?.filter((el) => el?.document_type === 2);
      return {
        ...state,
        labourEmployeeTaxDocumentInfo: taxDocuments,
      };
    }
    case actionTypes.SAVE_EMPLOYEE_DEPENDENTS_INFO: {
      return {
        ...state,
        labourEmployeeDependentsInfo: payload,
      };
    }
    case actionTypes.SAVE_CLIPBOARD_DATA: {
      const weekly = {
        0: "Monday",
        1: "Tuesday",
        2: "Wednesday",
        3: "Thursday",
        4: "Friday",
        5: "Saturday",
        6: "Sunday",
      };
      const data = { ...payload, weekly };
      const clipboardData = makeAllObjToArr(data, [
        "feature",
        "checkboxes_order_labels",
      ]);

      return {
        ...state,
        clipboardData: clipboardData,
      };
    }
    case actionTypes.SAVE_PROMOTIONS: {
      return {
        ...state,
        promotionsData: payload,
      };
    }
    case actionTypes.SAVE_PROMOTIONS_FORM_DATA: {
      let data = makeAllObjToArr(payload);
      data = {
        ...data,
        promotion_group: [
          { value: "add_new", label: "Add New" },
          ...data?.promotion_group,
        ],
      };
      return {
        ...state,
        promotionsFormData: data,
      };
    }
    case actionTypes.SAVE_PROMOTION_APPLICATION_DATA: {
      return {
        ...state,
        promotionApplicationData: payload,
      };
    }
    case actionTypes.SAVE_EDIT_PROMOTION_DATA: {
      return {
        ...state,
        promotionEditData: payload,
      };
    }
    case actionTypes.SAVE_PROMO_GROUP: {
      console.log(payload, "lllllllllllll");
      return {
        ...state,
        promotionsFormData: {
          ...state?.promotionsFormData,
          promotion_group: objToArr(payload),
        },
      };
    }
    case actionTypes.SAVE_PROMOTION_PERIOD: {
      const data = payload?.map((el) => ({
        ...el,
        days: typeof el?.days == "string" ? el?.days?.split(",") : el?.days,
        period_start: el["start_date"] ? el["start_date"] : el["period_start"],
        period_end: el["end_date"] ? el["end_date"] : el["period_end"],
      }));
      console.log(data, "ppppppppp");
      return {
        ...state,
        promotionPeriod: data,
      };
    }
    case actionTypes.SAVE_QUALIFICATION_CRITERIA: {
      return {
        ...state,
        promotionQualificationCriteria: payload,
      };
    }

    // qr order
    case actionTypes.SAVE_QR_ORDER_DATA: {
      return {
        ...state,
        qrOrderData: makeAllObjToArr(payload, ["qr_ordering"]),
      };
    }

    case actionTypes.EDIT_SAVE_PDF_MENU_DATA: {
      return {
        ...state,
        editPdfMenuData: payload,
      };
    }

    case actionTypes.SAVE_UPDATED_PDF_MENU_DATA: {
      return {
        ...state,
        qrOrderData: {
          ...state?.qrOrderData,
          qr_ordering: { ...state.qrOrderData.qr_ordering, ...payload },
        },
      };
    }

    case actionTypes.SAVE_MENU_SEQUENCING_DATA: {
      return {
        ...state,
        menuSequencingData: payload,
      };
    }

    case actionTypes.SAVE_QR_LIST: {
      return {
        ...state,
        qrList: payload,
      };
    }
    case actionTypes.SAVE_ORDRR_ONLINE_MENU_SEQUENCING_DATA: {
      return {
        ...state,
        ordrrOnlineMenuSequencingData: payload,
      };
    }
    case actionTypes.SAVE_ORDRR_ONLINE_DATA: {
      return {
        ...state,
        ordrrOnlineData: makeAllObjToArr(payload, ["order_online"]),
      };
    }
    case actionTypes.SAVE_DELIVERY_PARTNER_DATA: {
      return {
        ...state,
        deliveryPartnerData: makeAllObjToArr(payload, ["order_online"]),
      };
    }
    case actionTypes.SAVE_API_KEY_LISTING: {
      return {
        ...state,
        apiKeyList: payload,
      };
    }
    case actionTypes.SAVE_CONFIRM_PASSWORD_STATUS: {
      return {
        ...state,
        confirmPasswordStatus: payload,
      };
    }
    case actionTypes.SAVE_INTEGRATION_DATA: {
      return {
        ...state,
        integrationData: payload,
      };
    }
    case actionTypes.SAVE_INTEGRATION_EDIT_DATA: {
      return {
        ...state,
        integrationEditData: payload,
      };
    }
    default:
      return state;
  }
};
export default settingReducer;
